const BRANDS = [
  { id: "repsol", label: "Repsol", mark: "REPSOL", color: "#f36f21", text: "#ffffff", pattern: /\bREPSOL\b/ },
  { id: "moeve", label: "Moeve / Cepsa", mark: "MOEVE", color: "#6d2cff", text: "#ffffff", pattern: /\b(MOEVE|CEPSA)\b/ },
  { id: "galp", label: "Galp", mark: "galp", color: "#ef6c00", text: "#ffffff", pattern: /\bGALP\b/ },
  { id: "ballenoil", label: "Ballenoil", mark: "ballenoil", color: "#f6c900", text: "#132132", pattern: /\bBALLENOIL\b/ },
  { id: "plenergy", label: "Plenergy", mark: "PLENERGY", color: "#f5cf18", text: "#102b3f", pattern: /\b(PLENERGY|PLENOIL)\b/ },
  { id: "shell", label: "Shell", mark: "SHELL", color: "#ffd500", text: "#c8102e", pattern: /\bSHELL\b/ },
  { id: "petroprix", label: "Petroprix", mark: "PETROPRIX", color: "#e62b2f", text: "#ffffff", pattern: /\bPETROPRIX\b/ },
  { id: "petronor", label: "Petronor", mark: "PETRONOR", color: "#006f45", text: "#ffffff", pattern: /\bPETRONOR\b/ },
  { id: "bp", label: "bp", mark: "bp", color: "#159447", text: "#ffffff", pattern: /(^|\s)BP($|\s)|\bBP OIL\b/ },
  { id: "carrefour", label: "Carrefour", mark: "Carrefour", color: "#1455a0", text: "#ffffff", pattern: /\bCARREFOUR\b/ },
  { id: "avia", label: "AVIA", mark: "AVIA", color: "#e21d2b", text: "#ffffff", pattern: /\bAVIA\b/ },
  { id: "q8", label: "Q8", mark: "Q8", color: "#143b82", text: "#ffffff", pattern: /(^|\s)Q8($|\s)/ },
  { id: "t9", label: "T9", mark: "T9", color: "#102d4f", text: "#ffffff", pattern: /(^|\s)T9($|\s)/ },
  { id: "alcampo", label: "Alcampo", mark: "alcampo", color: "#e30613", text: "#ffffff", pattern: /\bALCAMPO\b/ },
  { id: "bonarea", label: "bonÀrea", mark: "bonÀrea", color: "#00854a", text: "#ffffff", pattern: /\bBONAREA\b/ },
  { id: "eroski", label: "Eroski", mark: "EROSKI", color: "#e30613", text: "#ffffff", pattern: /\bEROSKI\b/ },
  { id: "esclatoil", label: "EsclatOil", mark: "EsclatOil", color: "#e43b2f", text: "#ffffff", pattern: /\bESCLATOIL\b/ },
  { id: "campsa", label: "Campsa", mark: "CAMPSA", color: "#d9272e", text: "#ffffff", pattern: /\bCAMPSA\b/ },
  { id: "valcarce", label: "Valcarce", mark: "VALCARCE", color: "#005baa", text: "#ffffff", pattern: /\bVALCARCE\b/ },
  { id: "eni", label: "Eni", mark: "eni", color: "#ffd100", text: "#111111", pattern: /(^|\s)ENI($|\s)/ },
  { id: "tamoil", label: "Tamoil", mark: "TAMOIL", color: "#0c8a43", text: "#ffffff", pattern: /\bTAMOIL\b/ },
  { id: "disa", label: "DISA", mark: "DISA", color: "#f3c400", text: "#193452", pattern: /\bDISA\b/ },
  { id: "gasexpress", label: "GasExpress", mark: "GASexpress", color: "#f7931d", text: "#ffffff", pattern: /\bGASEXPRESS\b/ },
  { id: "beroil", label: "Beroil", mark: "beroil", color: "#ec1c24", text: "#ffffff", pattern: /\bBEROIL\b/ },
  { id: "meroil", label: "Meroil", mark: "MEROIL", color: "#ef3d33", text: "#ffffff", pattern: /\bMEROIL\b/ },
  { id: "petrocat", label: "Petrocat", mark: "PETROCAT", color: "#ef7d00", text: "#ffffff", pattern: /\bPETROCAT\b/ },
];

function normalize(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Z0-9]+/gi, " ")
    .trim()
    .toUpperCase();
}

export function getStationBrand(station) {
  const raw = normalize(station?.brand || station?.name);
  return BRANDS.find((brand) => brand.pattern.test(raw)) || null;
}

export function getBrandById(id) {
  return BRANDS.find((brand) => brand.id === id) || null;
}

export function getBrandOptions(stations) {
  const counts = new Map();
  let otherCount = 0;

  for (const station of stations) {
    const brand = getStationBrand(station);
    if (brand) counts.set(brand.id, (counts.get(brand.id) || 0) + 1);
    else otherCount += 1;
  }

  const options = BRANDS
    .filter((brand) => counts.has(brand.id))
    .map((brand) => ({ ...brand, count: counts.get(brand.id) }))
    .sort((left, right) => right.count - left.count || left.label.localeCompare(right.label, "es"));

  if (otherCount) {
    options.push({
      id: "other",
      label: "Otras",
      mark: "OTRAS",
      color: "#e9edf2",
      text: "#344054",
      count: otherCount,
    });
  }

  return options;
}

export function stationMatchesBrand(station, brandId) {
  if (brandId === "all") return true;
  const brand = getStationBrand(station);
  return brandId === "other" ? !brand : brand?.id === brandId;
}
